import { getActiveRatingFilters, getActiveTagFilters } from '../../selectors/filters';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';
import { fetchReviews } from '../../services/reviews';
import { TThunkAction } from '../../types/redux';
import { setAnswers } from '../answers';
import { setRatingFilters, setTagFilters } from '../filters';
import { setReviews } from './actions';
import { prepareTagsFiltersStore, prepareTagsFiltersRequest } from '../../mappers/prepareTagsFilters';
import { prepareSortRequest } from '../../mappers/prepareSort/prepareSortRequest';
import { getActiveSortValue } from '../../selectors/sort';

interface ILoadReviews {
  page?: number;
  getAllItems?: boolean;
}
//TODO: В след задачах добавить cancellationToken и spinner
export function loadReviews(props: ILoadReviews | void): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;
    const state = getState();

    const { newbuildingId } = getNewbuildingInfo(state);
    const ratingFilters = getActiveRatingFilters(state);
    const tagFilter = getActiveTagFilters(state);
    const sort = getActiveSortValue(state);

    try {
      const { availableFilters, tags, answers, reviews, hasMore, page } = await fetchReviews({
        httpApi,
        parameters: {
          newbuildingId,
          filters: ratingFilters,
          page: props?.page,
          getAllItems: props?.getAllItems,
          tag: prepareTagsFiltersRequest(tagFilter),
          sort: prepareSortRequest(sort),
        },
      });

      dispatch(setRatingFilters(availableFilters));
      dispatch(setTagFilters(prepareTagsFiltersStore(tags)));
      dispatch(setAnswers(answers));
      dispatch(
        setReviews({
          ...reviews,
          hasMore,
          page: page || 0,
        }),
      );
    } catch (error) {
      logger.error(error, {
        domain: 'reviews#loadReviews',
        message: error.message,
      });
    }
  };
}
